function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLocationRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15a2 2 0 11.001-4.001A2 2 0 0116 15zm0-12C10.478 3 6 7.477 6 13c0 7 10 16 10 16s10-9 10-16c0-5.523-4.478-10-10-10zm0 14c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-12c4.411 0 8 3.589 8 8 0 4.056-4.938 10.021-8 13.188C12.938 23.021 8 17.056 8 13c0-4.411 3.589-8 8-8z",
    fill: props.color
  }));
}

export default SvgIconLocationRexOutline;